import React from "react";
import { style } from "typestyle";
// @ts-ignore
import BackButton from "./BackButton";
import LogoutButton from "../LogoutButton/LogoutButton";
// @ts-ignore
import GoToAppButton from "./GoToAppButton";
import PilotInvoicingPortalButton from "./pilotInvoicingButton/PilotInvoicingPortalButton";

/*
 * @deprecated
 * This component contains BackButton and it's logic depends on page where it is displayed
 * thus each page should have it's own BackButton.
 * Use components/JumbotronLayout or components/NavBar
 */
const NavBar = (): JSX.Element => (
  <div
    className={style({
      height: "64px",
      backgroundColor: "#212121",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxSizing: "border-box",
      padding: "0px 32px",
    })}
  >
    <div
      className={style({
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flex: 1,
      })}
    >
      <BackButton />
    </div>
    <div
      className={style({
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flex: 1,
        $nest: {
          "&>*": {
            marginLeft: "56px",
          },
          "&:last-child": {
            marginLeft: 0,
          },
        },
      })}
    >
      <LogoutButton />
      <PilotInvoicingPortalButton />
      <GoToAppButton />
    </div>
  </div>
);

export default NavBar;
